import Axios from 'axios'
import store from '../store'
import strings from '@/strings.js'

const team = {
  getWebapigwUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE
  },
  getClientId() {
    return store.getters['Client/clientId']
  },
  getMyTeams() {
    return Axios.get(`${this.getWebapigwUrl()}/api/v1/clients/${this.getClientId()}/employee-groups/employees?limitOfEmployees=${strings.maxSearchTeam}`, {
      ignoreGlobalCatch: true,
    })
  },
  searchEmployees(filter){
    return Axios.get(`${this.getWebapigwUrl()}/api/v1/clients/${this.getClientId()}/employee-groups/${filter.teamId}/employees/team-managers?term=${filter.term}&pageNumber=${filter.pageNumber}&pageSize=${filter.pageSize}`,{
      ignoreGlobalCatch: true,
    })
  }
}

export default team
